type Callback = () => void;

export const nextTick = (fn: Callback) => {
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      fn();
    });
  });
};
